import { render } from "./InvoiceSubs.vue?vue&type=template&id=c9de89d4&scoped=true&ts=true"
import script from "./InvoiceSubs.vue?vue&type=script&lang=ts"
export * from "./InvoiceSubs.vue?vue&type=script&lang=ts"

import "./InvoiceSubs.vue?vue&type=style&index=0&id=c9de89d4&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9de89d4"]])

export default __exports__